import React from 'react';
import './SimpleHero.css';

const linkProps = (href) =>
  /^https?:\/\//i.test(href)
    ? { href, target: '_blank', rel: 'noopener noreferrer' }
    : { href };

const SimpleHero = ({
  title = 'Welcome to GN Bank',
  subtitle = 'Dear Valued Customer, All cashier’s checks issued by the Bank that remain uncashed for more than 60 days will be reversed and voided, and a stop payment will be placed on the check.  Monthly Account Service Fee: ',
  primaryLabel = null,
  primaryHref = null,
  secondaryLabel,
  secondaryHref,
  align = 'center', // 'center' | 'left'
  variant = 'light', // 'light' | 'muted' | 'sofi'
  imageSrc,
  imageAlt = '',
  imageOn = 'right', // 'right' | 'left'
  tiltImage = false,
  badges = [], // array of strings
}) => {
  const hasImage = Boolean(imageSrc);
  return (
    <section className={`simple-hero simple-hero--${variant}`}>
      <div className="gn-container">
        <div className={`simple-hero__grid ${imageOn === 'left' ? 'simple-hero__grid--image-left' : ''}`}>
          {hasImage && imageOn === 'left' && (
            <div className={`simple-hero__image ${tiltImage ? 'simple-hero__image--tilt' : ''}`}>
              <img src={imageSrc} alt={imageAlt} />
            </div>
          )}
          <div className={`simple-hero__inner simple-hero__inner--${align}`}>
            <h1 className="simple-hero__title">{title}</h1>
            {subtitle && <p className="simple-hero__subtitle">{subtitle}</p>}
            {badges && badges.length > 0 && (
              <div className="simple-hero__badges">
                {badges.map((b, i) => (
                  <span className="hero-badge" key={i}>{b}</span>
                ))}
              </div>
            )}
            <div className="simple-hero__ctas">
              {primaryLabel && primaryHref && (
                <a className="btn btn-gn-primary" {...linkProps(primaryHref)}>{primaryLabel}</a>
              )}
              {secondaryLabel && secondaryHref && (
                <a className="btn btn-gn-secondary ms-2" {...linkProps(secondaryHref)}>{secondaryLabel}</a>
              )}
            </div>
          </div>
          {hasImage && imageOn === 'right' && (
            <div className={`simple-hero__image ${tiltImage ? 'simple-hero__image--tilt' : ''}`}>
              <img src={imageSrc} alt={imageAlt} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default SimpleHero;


